import { formatCurreny } from "../../../../utils/currency.util";

export default function FinanceSummary({ data }) {

    const formatDate = (date) => new Date(date).toLocaleDateString();

    return (
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th scope="col"></th>
                        <th scope="col">{`${formatDate(data.prevYearStartDate)} - ${formatDate(data.prevYearEndDate)}`}</th>
                        <th scope="col">{`${formatDate(data.currentYearStartDate)} - ${formatDate(data.currentYearEndDate)}`}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Cumulative Revenue</td>
                        <td>{formatCurreny(data.prevRevenue)}</td>
                        <td>{formatCurreny(data.currentRevenue)}</td>
                    </tr>
                    <tr>
                        <td>As At Revenue</td>
                        <td>{formatCurreny(data.prevAsAtRevenue)}</td>
                        <td>{formatCurreny(data.currentAsAtRevenue)}</td>
                    </tr>
                    <tr>
                        <td>Customer Outstanding</td>
                        <td>{formatCurreny(data.prevYearCustomerOutstanding)}</td>
                        <td>{formatCurreny(data.currentYearCustomerOutstanding)}</td>
                    </tr>
                    <tr>
                        <td>Supplier Outstanding</td>
                        <td>{formatCurreny(data.prevYearSupOutstanding)}</td>
                        <td>{formatCurreny(data.currentYearSupOutstanding)}</td>
                    </tr>
                    <tr>
                        <td>Over Credit Limit Customer</td>
                        <td>{formatCurreny(data.prevYearOverCredit)}</td>
                        <td>{formatCurreny(data.currentYearOverCredit)}</td>
                    </tr>
                </tbody>
            </table>
        </div>

    )
}